import z from 'zod'

export enum DimensionType {
    PROJECT = 'PROJECT', DEPARTMENT = 'DEPARTMENT', TAG = 'TAG', SYSTEM = 'SYSTEM'
}

export type Dimension = {
    name: string,
    type: DimensionType,
    isEnabled: boolean
}

export const DimensionSchema = z.object({
    name: z.string().nonempty(),
    type: z.enum(DimensionType),
    isEnabled: z.boolean()
})